import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';

import { AppComponent } from './app.component';
import { FormPageComponent } from './form-page/form-page.component';
import { AppRoutingModule } from './app-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateService} from './shared/services/translate.service';
import {TranslatePipe} from './translate.pipe';
import {HttpClientModule} from '@angular/common/http';
import { SingleComponent } from './single/single.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { RecapitulationComponent } from './recapitulation/recapitulation.component';
import { PayMethodComponent } from './pay-method/pay-method.component';
import { RecapFormComponent } from './recap-form/recap-form.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { AdminPageComponent } from './admin-page/admin-page.component';
import {JwtHelperService} from '@auth0/angular-jwt';
import {
  MatButtonModule, MatCardModule,
  MatCheckboxModule, MatDatepickerModule, MatDialogModule,
  MatIconModule, MatInputModule, MatListModule,
  MatMenuModule, MatNativeDateModule,
  MatProgressSpinnerModule, MatSelectModule,
  MatSidenavModule, MatSnackBarModule, MatSortModule,
  MatTableModule, MatTabsModule,
  MatToolbarModule, MatTooltipModule, MatTreeModule
} from '@angular/material';
import {OverlayModule} from '@angular/cdk/overlay';
import { RacerTabComponent } from './racer-tab/racer-tab.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import { TopbarComponent } from './topbar/topbar.component';
import { CutLoginPipe } from './topbar/pipe/cut-login.pipe';
import {TableComponent} from './table/table.component';
import { RacesComponent } from './races/races.component';
import { SettingsComponent } from './settings/settings.component';
import {RoleGuard} from './shared/guards/Role/role.guard';
import { RacerDetailComponent } from './racer-detail/racer-detail.component';
import { FormBuilderComponent } from './form-builder/form-builder.component';
import { FormBuilderDetailComponent } from './form-builder-detail/form-builder-detail.component';
import { EditableTableComponent } from './editable-table/editable-table.component';
import { ShowFormComponent } from './show-form/show-form.component';
import { FormItemsComponent } from './form-items/form-items.component';
import { FormItemsDetailsComponent } from './form-items-details/form-items-details.component';
import { RaceDetailComponent } from './race-detail/race-detail.component';
import { SportTypeTabComponent } from './sport-type-tab/sport-type-tab.component';
import { SportTypeDetailComponent } from './sport-type-detail/sport-type-detail.component';
import { RaceDetailInfoComponent } from './race-detail-info/race-detail-info.component';
import { StartFeeComponent } from './start-fee/start-fee.component';
import { AllRacersComponent } from './all-racers/all-racers.component';
import { HeaderComponent } from './header/header.component';
import { TreeTableComponent } from './tree-table/tree-table.component';
import { GoPaySettingComponent } from './go-pay-setting/go-pay-setting.component';
import { GoPaySettingDetailComponent } from './go-pay-setting-detail/go-pay-setting-detail.component';
import { RecapitulationFormComponent } from './recapitulation-form/recapitulation-form.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { DialogComponent } from './dialog/dialog.component';
import { FioComponent } from './fio/fio.component';
import { FioDetailComponent } from './fio-detail/fio-detail.component';
import { RaceFioComponent } from './race-fio/race-fio.component';
import { AccountInfoComponent } from './account-info/account-info.component';
import { MailComponent } from './mail/mail.component';
import {NgxEditorModule} from 'ngx-editor';
import {AngularFontAwesomeModule} from 'angular-font-awesome';
import { RacerPayDetailComponent } from './racer-pay-detail/racer-pay-detail.component';
import { TrackCatComponent } from './track-cat/track-cat.component';
import { VoucherComponent } from './voucher/voucher.component';
import { StartNumberComponent } from './start-number/start-number.component';
import { CashInfoComponent } from './cash-info/cash-info.component';
import { VoucherDetailComponent } from './voucher-detail/voucher-detail.component';
import { FilterRacerPipe } from './shared/pipes/fileterRacerPipe/filter-racer.pipe';
import { GdprPageComponent } from './gdpr-page/gdpr-page.component';

export function setupTranslateFactory(
  service: TranslateService): Function {
  return () => service.use('cz');
}

@NgModule({
  declarations: [
    AppComponent,
    FormPageComponent,
    TranslatePipe,
    SingleComponent,
    RecapitulationComponent,
    PayMethodComponent,
    RecapFormComponent,
    LoginPageComponent,
    AdminPageComponent,
    RacerTabComponent,
    DashboardComponent,
    FooterComponent,
    LoaderComponent,
    TopbarComponent,
    CutLoginPipe,
    TableComponent,
    RacesComponent,
    SettingsComponent,
    RacerDetailComponent,
    FormBuilderComponent,
    FormBuilderDetailComponent,
    EditableTableComponent,
    ShowFormComponent,
    FormItemsComponent,
    FormItemsDetailsComponent,
    RaceDetailComponent,
    SportTypeTabComponent,
    SportTypeDetailComponent,
    RaceDetailInfoComponent,
    StartFeeComponent,
    AllRacersComponent,
    HeaderComponent,
    TreeTableComponent,
    GoPaySettingComponent,
    GoPaySettingDetailComponent,
    RecapitulationFormComponent,
    SearchInputComponent,
    DialogComponent,
    FioComponent,
    FioDetailComponent,
    RaceFioComponent,
    AccountInfoComponent,
    MailComponent,
    RacerPayDetailComponent,
    TrackCatComponent,
    VoucherComponent,
    StartNumberComponent,
    CashInfoComponent,
    VoucherDetailComponent,
    FilterRacerPipe,
    GdprPageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    OverlayModule,
    FontAwesomeModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatTableModule,
    MatSortModule,
    MatTooltipModule,
    MatTabsModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatCardModule,
    MatTreeModule,
    MatSnackBarModule,
    MatListModule,
    MatDialogModule,
    NgxEditorModule,
    AngularFontAwesomeModule
  ],
  providers: [TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [
        TranslateService
      ],
      multi: true
    }
  ],
  entryComponents: [DialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
